<template>
  <main class="w-full flex-grow p-6">
    <BackButton />
    <div class="flex justify-between items-center">
      <div class="">
        <h1 class="text-3xl font-bold text-app-default">Carousel/Detail</h1>
      </div>
      <div class="flex">
        <div @click="showModalDestroy" class="mr-5 cursor-pointer">
          <fas icon="trash-alt" class="text-red-600 text-2xl" />
        </div>
      </div>
    </div>

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">
              Carousel Large (landscape: 2560 px X 1347 px)
            </div>
            <div
              @click="showModalLargeCarouselFile"
              class="mr-5 cursor-pointer"
            >
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div class="flex">
            <img
              class="w-9/12 lg:w-w-3/4 mr-3 h-44 lg:h-80"
              :src="dataCarousel.carousel_large"
              alt="23paskal"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">
              Carousel Small (portrait: 1170 px X 1080 px)
            </div>
            <div
              @click="showModalSmallCarouselFile"
              class="mr-5 cursor-pointer"
            >
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div class="flex">
            <img
              class="w-full lg:w-1/2 mr-3 h-44 lg:h-80"
              :src="dataCarousel.carousel_small"
              alt="23paskal"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">Info</div>
            <div @click="showModalEditCarouselInfo" class="mr-5 cursor-pointer">
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div class="font-semibold">Title</div>
          <div v-if="dataCarousel.title !== ''" class="ml-5">
            {{ dataCarousel.title }}
          </div>
          <div v-else class="ml-5">-</div>
          <div class="font-semibold">Description</div>
          <div v-if="dataCarousel.description !== ''" class="ml-5">
            {{ dataCarousel.description }}
          </div>
          <div v-else class="ml-5">-</div>
        </div>
      </div>
    </div>

    <!-- Modal destroy -->
    <div
      v-if="modalDestroy"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 400px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <button
            @click.self="showModalDestroy"
            class="fill-current h-6 w-6 absolute right-0 top-0 m-6 font-3xl font-bold"
          >
            &times;
          </button>
          <div class="px-6 py-3 text-xl border-b font-bold">Warning !</div>
          <div class="p-6 flex-grow">
            Continue To Delete This Carousel
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalDestroy"
                type="button"
                class="bg-green-400 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click="deleteCarousel"
                type="button"
                class="bg-red-500 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ deleteButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalDestroy"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- Modal Update -->
    <div
      v-if="modalInfoCarousel"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 800px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <button
            @click.self="showModalEditCarouselInfo"
            class="fill-current h-6 w-6 absolute right-0 top-0 m-6 font-3xl font-bold"
          >
            &times;
          </button>
          <div class="px-6 py-3 text-xl border-b font-bold">Edit Content</div>
          <div class="p-6 flex-grow">
            <div class="flex flex-wrap">
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80">Title</label>
                <!-- <input v-model="update.title" type="text" class="w-full h-9 px-2 rounded-md border-2 border-gray-200 focus:outline-none focus:ring transition duration-200 mb-5" placeholder="Title"> -->
                <input
                  v-model="update.title"
                  @keyup="titleChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.title
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Name"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.title_msg }}
                </div>
              </div>
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Description</label
                >
                <!-- <textarea v-model="update.description" rows="5" class="w-full pl-3 pr-3 py-2 rounded-md border-2 border-gray-200 focus:outline-none focus:ring transition duration-200  mb-4" placeholder="Description"></textarea> -->
                <textarea
                  v-model="update.description"
                  @keyup="descriptionChange"
                  rows="5"
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.description
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Description"
                >
                </textarea>
                <div
                  class="text-right text-sm "
                  :class="[
                    update?.description?.length <= 2000
                      ? 'text-gray-600'
                      : 'text-red-600',
                  ]"
                >
                  {{ update?.description?.length }} used out of 2000 characters
                </div>
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.description_msg }}
                </div>
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalEditCarouselInfo"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click="updateCarouselInfo"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalEditCarouselInfo"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- Modal Carousel large -->
    <div
      v-if="modalLargeCarousel"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 800px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">
              Update Carousel Large (2560 px X 1347 px)
            </div>
            <div class="">
              <button
                @click.self="showModalLargeCarouselFile"
                class="font-3xl font-bold p-6"
              >
                &times;
              </button>
            </div>
          </div>
          <div class="p-6 flex-grow">
            <div class="">
              <div
                class="border-dotted border-2 border-black p-2 rounded-lg"
                @drop="previewFileLargeCarousel"
              >
                <input
                  type="file"
                  accept="image/*"
                  @change="previewFileLargeCarousel"
                  id="carousel_large"
                  class="opacity-0 hidden"
                />
                <div class="flex flex-row">
                  <div
                    v-if="avatar.previewLargeCarousel"
                    class="mr-1 relative rounded-lg w-full"
                  >
                    <button
                      class="absolute right-2 top-2"
                      type="button"
                      @click="removeLargeCarouselFile()"
                    >
                      <fas icon="trash-alt" class="text-red-600 text-3xl" />
                    </button>
                    <img
                      :src="avatar.previewLargeCarousel"
                      class="w-full h-80 rounded-lg"
                    />
                  </div>
                  <div
                    v-if="avatar.previewLargeCarousel === null"
                    v-cloak
                    @click="chooseLargeCarouselFile()"
                    class="w-full h-80 mr-1 rounded-lg cursor-pointer bg-gray-200 flex items-center justify-center"
                  >
                    <fas icon="image" class="text-gray-600 text-3xl" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalLargeCarouselFile"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                :disabled="avatar.previewLargeCarousel === null"
                @click="updateLargeCarousel"
                type="button"
                class="text-gray-200 rounded px-4 py-2 w-32"
                :class="[
                  !avatar.previewLargeCarousel ? 'bg-gray-500' : 'bg-blue-600',
                ]"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalLargeCarouselFile"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- Modal Carousel Small -->
    <div
      v-if="modalSmallCarousel"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 600px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">
              Update Carousel Small (1170 px X 1080 px)
            </div>
            <div class="">
              <button
                @click.self="showModalSmallCarouselFile"
                class="font-3xl font-bold p-6"
              >
                &times;
              </button>
            </div>
          </div>
          <div class="p-6 flex-grow">
            <div class="">
              <div
                class="border-dotted border-2 border-black p-2 rounded-lg"
                @drop="previewFileSmallCarousel"
              >
                <input
                  type="file"
                  accept="image/*"
                  @change="previewFileSmallCarousel"
                  id="carousel_small"
                  class="opacity-0 hidden"
                />
                <div class="flex flex-row">
                  <div
                    v-if="avatar.previewSmallCarousel"
                    class="mr-1 relative rounded-lg w-full"
                  >
                    <button
                      class="absolute right-2 top-2"
                      type="button"
                      @click="removeSmallCarouselFile()"
                    >
                      <fas icon="trash-alt" class="text-red-600 text-3xl" />
                    </button>
                    <img
                      :src="avatar.previewSmallCarousel"
                      class="w-full h-80 rounded-lg"
                    />
                  </div>
                  <div
                    v-if="avatar.previewSmallCarousel === null"
                    v-cloak
                    @click="chooseSmallCarouselFile()"
                    class="w-full h-80 mr-1 rounded-lg cursor-pointer bg-gray-200 flex items-center justify-center"
                  >
                    <fas icon="image" class="text-gray-600 text-3xl" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalSmallCarouselFile"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                :disabled="!avatar.previewSmallCarousel"
                @click="updateSmallCarousel"
                type="button"
                class="text-gray-200 rounded px-4 py-2 w-32"
                :class="[
                  !avatar.previewSmallCarousel ? 'bg-gray-500' : 'bg-blue-600',
                ]"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalSmallCarouselFile"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <Warning />
    <SuccessNotif />
  </main>
</template>

<script>
import API from "../../api";
import Warning from "../../components/Warning.vue";
import BackButton from "../../components/BackButton.vue";
import SuccessNotif from "../../components/SuccessNotif.vue";
export default {
  name: "ContentDetail",
  components: {
    Warning,
    BackButton,
    SuccessNotif,
  },
  data() {
    return {
      dataCarousel: {},
      modalDestroy: false,
      modalInfoCarousel: false,
      modalLargeCarousel: false,
      modalSmallCarousel: false,
      errors: {
        title: false,
        title_msg: "",
        description: false,
        description_msg: "",
      },
      update: {
        id: null,
        title: "",
        description: "",
      },
      avatar: {
        previewLargeCarousel: null,
        fileLargeCarousel: null,
        previewSmallCarousel: null,
        fileSmallCarousel: null,
      },
      saveButton: "Save",
      deleteButton: "Delete",
    };
  },
  methods: {
    descriptionChange: function(e) {
      this.description = e.target.value;
      this.errors.description = false;
      this.errors.description_msg = "";
    },
    titleChange: function(e) {
      this.title = e.target.value;
      this.errors.title = false;
      this.errors.title_msg = "";
    },
    chooseLargeCarouselFile: function() {
      document.getElementById("carousel_large").click();
    },
    chooseSmallCarouselFile: function() {
      document.getElementById("carousel_small").click();
    },
    removeLargeCarouselFile: function() {
      this.avatar.previewLargeCarousel = null;
      this.avatar.fileLargeCarousel = null;
    },
    removeSmallCarouselFile: function() {
      this.avatar.previewSmallCarousel = null;
      this.avatar.fileSmallCarousel = null;
    },
    previewFileLargeCarousel: function(event) {
      let input = event.target;
      if (input.files) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.avatar.previewLargeCarousel = e.target.result;
        };
        this.avatar.fileLargeCarousel = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
    },
    previewFileSmallCarousel: function(event) {
      let input = event.target;
      if (input.files) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.avatar.previewSmallCarousel = e.target.result;
        };
        this.avatar.fileSmallCarousel = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
    },
    showModalDestroy: function() {
      this.modalDestroy = !this.modalDestroy;
    },
    showModalLargeCarouselFile: function() {
      this.avatar = {
        previewLargeCarousel: null,
        fileLargeCarousel: null,
      };
      this.modalLargeCarousel = !this.modalLargeCarousel;
    },
    showModalSmallCarouselFile: function() {
      this.avatar = {
        previewSmallCarousel: null,
        fileSmallCarousel: null,
      };
      this.modalSmallCarousel = !this.modalSmallCarousel;
    },
    showModalEditCarouselInfo: function() {
      this.update.id = this.dataCarousel.id;
      this.update.title = this.dataCarousel.title;
      this.update.description = this.dataCarousel.description;
      this.modalInfoCarousel = !this.modalInfoCarousel;
    },
    deleteCarousel: async function() {
      this.deleteButton = "Loading...";
      try {
        let res = await fetch(`${API}v1/admin/cms/carousel/delete`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify({
            id: this.dataCarousel.id,
          }),
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this.modalDestroy = false;
          this.deleteButton = "Delete";
          this._error(respon.message);
          return;
        }
        this.modalDestroy = false;
        this.deleteButton = "Delete";
        this.$router.push(`/carousel`);
        this._success("Data deleted.");
      } catch (err) {
        this.deleteButton = "Delete";
        this.modalDestroy = false;
        this._error("internal server error");
      }
    },
    updateLargeCarousel: async function() {
      this.saveButton = "Loading...";
      let formdata = new FormData();
      formdata.append("carousel_large", this.avatar.fileLargeCarousel);
      formdata.append("id", this.dataCarousel.id);
      try {
        let res = await fetch(`${API}v1/admin/cms/carousel/update-large`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        const response = await res.json();
        if (response.status !== 200) {
          this.modalLargeCarousel = false;
          this.saveButton = "Save";
          this._error(response.message);
          return;
        }
        this.modalLargeCarousel = false;
        this.saveButton = "Save";
        this.detailCarousel();
        this._success("Data updated.");
      } catch (err) {
        this.saveButton = "Save";
        this.modalLargeCarousel = false;
        this._error("internal server error");
      }
    },
    updateSmallCarousel: async function() {
      this.saveButton = "Loading...";
      let formdata = new FormData();
      formdata.append("carousel_small", this.avatar.fileSmallCarousel);
      formdata.append("id", this.dataCarousel.id);
      try {
        let res = await fetch(`${API}v1/admin/cms/carousel/update-small`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        const response = await res.json();
        if (response.status !== 200) {
          this.modalSmallCarousel = false;
          this.saveButton = "Save";
          this._error(response.message);
          return;
        }
        this.modalSmallCarousel = false;
        this.saveButton = "Save";
        this.detailCarousel();
        this._success("Data updated.");
      } catch (err) {
        this.saveButton = "Save";
        this.modalSmallCarousel = false;
        this._error("internal server error");
      }
    },
    updateCarouselInfo: async function() {
      this.saveButton = "Loading...";
      try {
        let res = await fetch(`${API}v1/admin/cms/carousel/update`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify({
            id: this.dataCarousel.id,
            title: this.update.title,
            description: this.update.description,
          }),
        });
        const response = await res.json();
        if (response.status !== 200) {
          if (response.message === "ERR_FORM") {
            response.data.map((item) => {
              if (item.key === "title") {
                this.errors.title = true;
                this.errors.title_msg = item.message;
              }
              if (item.key === "description") {
                this.errors.description = true;
                this.errors.description_msg = item.message;
              }
            });
            this.saveButton = "Save";
            return;
          }
          this.modalInfoCarousel = false;
          this.saveButton = "Save";
          this._error(response.message);
          return;
        }
        this.modalInfoCarousel = false;
        this.detailCarousel();
        this.saveButton = "Save";
        this._success("Data updated.");
      } catch (err) {
        this.modalInfoCarousel = false;
        this.saveButton = "Save";
        this._error("internal server error");
      }
    },
    detailCarousel: async function() {
      try {
        let res = await fetch(`${API}v1/admin/cms/carousel/${this.$route.params.id}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.dataCarousel = respon.data;
      } catch (err) {
        this._error("internal server error");
      }
    },
    _error: function(message) {
      this.$store.dispatch("warning", {
        isError: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("warning", {
          isError: false,
          message: "",
        });
      }, 5000);
    },
    _success: function(message) {
      this.$store.dispatch("success", {
        isSuccess: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("success", {
          isSuccess: false,
          message: "",
        });
      }, 5000);
    },
  },
  created() {
    this.detailCarousel();
  },
};
</script>
